import { MENU_ITEMS } from "@consts";
export default {
	name: "TheDesktopNavigation",
	data() {
		return {
			menuData: [],
			isBlueBranding: false,
		};
	},
	computed: {
		submenuIsOpen() {
			return this.menuData.some((entry) => entry.submenuIsOpen === true);
		},
	},
	watch: {
		submenuIsOpen(value) {
			this.$store.commit("navigation/toggleDesktopSubMenu", value);
		},
		isBlueBranding(value) {
			this.blueBrandingLocalKey = value;
		},
		"$store.state.features.loaded"(loaded) {
			if (loaded) {
				this.isBlueBranding = Boolean(
					this.isFeatureEnabled("BlueBranding")
				);
			}
		},
	},
	created() {
		const reduceCallback = (acc, item) => {
			if (item.mobileOnly === true) {
				return acc;
			}

			const newItem = {
				...item,
				title: item.title || item.label || "",
			};

			if (Array.isArray(item.submenu)) {
				newItem.submenu = item.submenu.map((entry) => ({
					...entry,
					sectionEntries: Array.isArray(entry.sectionEntries)
						? entry.sectionEntries.reduce(reduceCallback, [])
						: entry.sectionEntries,
				}));
			}

			acc.push(newItem);
			return acc;
		};

		this.menuData = MENU_ITEMS.reduce(reduceCallback, []);
	},
	mounted() {
		// Post-hydration: avoid SSR/client mismatch by flipping after mount.
		this.isBlueBranding = Boolean(this.isFeatureEnabled("BlueBranding"));
	},
};
